import React from "react";
import { ErrorBoundary } from "../errorHandling/errorBoundary.jsx";
import { Link } from "react-router-dom";
import BetslipStore from "./../../flux/BetslipStore";
import { isMobile } from "react-device-detect";
import GBETHelper from "../gbetutils";

class MobileFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            betslipCounter: 0,
            multipleBetslipCounter: 0
        };
        this.onLinkSelected = this.handleLinkSelected.bind(this);
        this.onSearchClicked = this.handleSearchClicked.bind(this);
        this.handleAddRemovePrices = this.handleAddRemovePrices.bind(this);
        this.handleCloseClearBetslip = this.handleCloseClearBetslip.bind(this);
        this.handleRemoveBet = this.handleRemoveBet.bind(this);
        this.handleActiveTab = this.handleActiveTab.bind(this);

        BetslipStore.addChangeListener("STORE_ADD_REMOVE_PRICES", this.handleAddRemovePrices);
        BetslipStore.addChangeListener("STORE_COMMON_PLACED_BETS", this.handleAddRemovePrices);
        BetslipStore.addChangeListener("STORE_CLOSE_BETRECEIPT", this.handleCloseClearBetslip);
        BetslipStore.addChangeListener("STORE_CLEAR_BETSLIP", this.handleCloseClearBetslip);
        BetslipStore.addChangeListener("STORE_REMOVE_BET", this.handleRemoveBet);
        BetslipStore.addChangeListener("STORE_SET_SB_PRICES", this.handleAddRemovePrices);
        BetslipStore.addChangeListener("STORE_SB_PRICES_UPDATE", this.handleRemoveBet);

        this.wageringTabs = 0;

        if (configurationSettings.modes.indexOf("Sportsbook") > -1) {
            this.wageringTabs = this.wageringTabs + 1;
        }
        if (configurationSettings.modes.indexOf("Exchange") > -1) {
            this.wageringTabs = this.wageringTabs + 1;
        }
        let rootMode = configurationSettings.mode.toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName);
        let url = "/";
        if (configurationSettings.whiteLabel.toLocaleLowerCase() === "betdaq") {
            url = (GBEglobal.mode === ModeTypes.Sportsbook ? "/sportsbook" : "/exchange");
            if (GBEglobal.mode === ModeTypes.Multiples) {
                rootMode = "exchange";
            }
        }

        this.defaultFooterMenu = [
            {
                title: "Home",
                href: url,
                icon: "home"
            },
            {
                title: "Inplay",
                href: "/" + rootMode + "/inplay",
                icon: "inplay"
            }
        ];

        if (GBEglobal.settings.generalConfig?.showGDMInFooter) {
            this.defaultFooterMenu.push({
                title: "Gameday",
                href: "/gameday",
                icon: "gameday"
            });
        } else {
            if (configurationSettings.modes.indexOf("Multiples") !== -1 && GBEglobal.mode !== ModeTypes.Sportsbook) {
                this.defaultFooterMenu.push({
                    title: "Multiples",
                    href: "/multiples",
                    icon: "multiples"
                });
                const mbStorage = localStorage.getItem("GBET." + configurationSettings.whiteLabel + ".mb");
                if (mbStorage) {
                    try {
                        const mb = JSON.parse(mbStorage);
                        if (mb.s) {
                            this.state.multipleBetslipCounter = mb.s.length;
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        }
        this.defaultFooterMenu.push({
            title: "Betslip",
            href: "#betslip",
            dataLink: "Betslip",
            icon: "betslip"
        });
        this.defaultFooterMenu.push({
            title: "My Bets",
            dataLink: "MyBets",
            icon: "myBets"
        });

        this.casinoFooterMenu = [
            {
                title: "Home",
                href: "/",
                icon: "sport_icon home"
            },
            {
                title: "Search",
                href: "",
                icon: "search"
            }
        ];

        if (this.wageringTabs === 1) {
            this.casinoFooterMenu.push({
                title: "Back & Lay",
                href: "/",
                icon: "mode_icon exchange"
            });
        } else {
            this.casinoFooterMenu.push({
                title: "Exchange",
                href: "/exchange",
                icon: "mode_icon exchange"
            });
            this.casinoFooterMenu.push({
                title: "Sportsbook",
                href: "/sportsbook",
                icon: "mode_icon sportsbook"
            });
        }

        this.casinoFooterMenu.push({
            title: "My Bets",
            dataLink: "MyBets",
            icon: "sport_icon myBets"
        });
    }

    handleLinkSelected(event, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: value });
        switch (event.currentTarget.getAttribute("data-link")) {
            case "Betslip":
                this.props.ontogglePanel(true, this.state.betslipCounter);
                break;
            case "MyBets":
                this.props.onAccountClicked("current-bets");
                break;
        }
    }

    handleSearchClicked(event, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: value });
        this.props.onSearchClicked();
    }

    handleAddRemovePrices() {
        const betslipBets = BetslipStore.getBets();
        const state = {};

        if (GBEglobal.mode === ModeTypes.Multiples) {
            state.multipleBetslipCounter = betslipBets.length;
        } else {
            state.betslipCounter = betslipBets.length;
        }

        this.setState(state);
    }

    handleRemoveBet() {
        if (isMobile) {
            const thisComponent = this;
            setTimeout(function () {
                const betslipBets = BetslipStore.getBets();
                if (betslipBets.length === 0 && document.getElementById("container").classList.contains("rightPanelToggled")) {
                    thisComponent.props.ontogglePanel(true, 0);
                }
            }, 50);
        }
    }

    handleCloseClearBetslip() {
        //if (isMobile) {
        this.props.ontogglePanel(true, 0);
        //}
    }

    handleClick(e, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: value });
        const thisComponent = this;
        const rootMode = configurationSettings.mode.toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName);
        document.body.classList.remove("overflow-hidden");

        if (value !== "betslip" && configurationSettings.modes.indexOf("Multiples") !== -1) {
            if (value === "multiples" && thisComponent.state.multipleBetslipCounter > 0 && GBEglobal.mode === ModeTypes.Multiples) {
                e.preventDefault();
            }
        }

        if ((GBEglobal.mode === ModeTypes.Multiples && value === "multiples")) {
            this.props.ontogglePanel(true, 0);
        }

        //want a full page reload to stop listOrderChangeSince - check if going to new mode
        if (rootMode === "casino" && value === "betslip") {
            e.preventDefault();

            var sportsbookIndex = configurationSettings.modes.indexOf("Sportsbook");
            var exchangeIndex = configurationSettings.modes.indexOf("Exchange");
            var firstWageringIndex = 1000;
            if (sportsbookIndex > -1) {
                firstWageringIndex = Math.min(firstWageringIndex, sportsbookIndex);
            }
            if (exchangeIndex > -1) {
                firstWageringIndex = Math.min(firstWageringIndex, exchangeIndex);
            }
            window.location = configurationSettings.modes[firstWageringIndex].toLowerCase().replace("sportsbook", configurationSettings.sportsbookTabName) + "#betslip";
        }

        const path = e.currentTarget ? e.currentTarget.href.replace(configurationSettings.baseUrl, "") : "";
        if (path.indexOf(rootMode) === -1) {
            e.preventDefault();
            window.location = e.currentTarget.href;
        }
    }

    handleButtonClick(e, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: value });

        const isNativeiOS = GBETHelper.isNativeiOS();

        if (value === "customer-service" && GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.enabled) {
            if (GBEglobal.settings.zenDesk.customerService) {
                const url = GBEglobal.settings.zenDesk.customerService;
                const params = "left=" + (screen.width - 730) + ",top=30,width=1060,height=430,resizable=yes,scrollbars=auto";
                if (isNativeiOS) {
                    GBETHelper.openUrlWithAnchorTag(url, "_blank", true);
                } else {
                    window.open(url, "_blank", params);
                }
            } else {
                if (window.openChat !== undefined) {
                    window.openChat();
                } else {
                    window.zE.activate();
                }
            }
        } else if (value === "help" && GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.helpCenter !== undefined) {
            const url = GBEglobal.settings.zenDesk.helpCenter;
            const params = "left=" + (screen.width - 730) + ",top=30,width=1060,height=430,resizable=yes,scrollbars=auto";
            if (isNativeiOS) {
                GBETHelper.openUrlWithAnchorTag(url, "_blank", true);
            } else {
                window.open(url, "_blank", params);
            }
        }
    }

    handleActiveTab() {
        let activeTab;
        const url = window.location.pathname;

        if (url.indexOf("inplay") !== -1) {
            activeTab = "inplay";
        } else if (url.indexOf("multiples") !== -1) {
            activeTab = "multiples";
        } else {
            activeTab = "home";
        }
        return activeTab;
    }

    onAccountClicked(page) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: page });
        this.props.onAccountClicked(page);
    }

    onLogoutRequest(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "mobile-footer", eventAction: "click", eventLabel: value });
        this.props.onLogoutRequest();
    }

    onLoginWidgetShow() {
        this.props.onLoginWidgetShow(true);
    }

    render() {
        const showCasinoMenu = configurationSettings.mode === "casino" || configurationSettings.mode === "sportpools" || location.href.indexOf("promotions") !== -1 || location.href.indexOf("tutorials") !== -1;
        return (
            <ErrorBoundary componentName="MobileFooter">
                <nav className="navbar d-flex d-md-none" id="bottom-navbar">
                    <div className="mobile-action-icons">
                        <div className="navbar-tools">
                            {GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.helpCenter !== undefined &&
                                <button className="btn btn-primary d-md-inline-block" onClick={(e) => this.handleButtonClick(e, "help")}><span className="material-icons">help_outline</span></button>
                            }
                            <button className="btn btn-primary d-md-inline-block" onClick={this.onAccountClicked.bind(this, "my-preferences")}><span className="material-icons">settings</span></button>
                            {GBEglobal.settings.zenDesk !== undefined && GBEglobal.settings.zenDesk.enabled &&
                                <button className="btn btn-primary d-md-inline-block" onClick={(e) => this.handleButtonClick(e, "customer-service")}><span className="material-icons">headset_mic</span></button>
                            }
                            {this.props.isLoggedIn && <button className="btn btn-primary d-md-inline-block logout" onClick={this.onLogoutRequest.bind(this, "logout")}>Log out</button>}
                            {!this.props.isLoggedIn && <button className="btn btn-primary d-md-inline-block logout" onClick={this.onLoginWidgetShow.bind(this, "login")}>Log In</button>}
                        </div>
                    </div>
                    <ul className="navbar-nav">
                        {showCasinoMenu &&
                            this.casinoFooterMenu.map((element) => {
                                const props = {};
                                const activeTab = this.handleActiveTab() === element.title.replace(/ +/g, "").toLowerCase() ? " active" : "";

                                if (element.dataLink) {
                                    props["data-link"] = element.dataLink;
                                }
                                if (element.title === "My Bets") {
                                    return (
                                        <li className={"nav-item" + activeTab} key={element.title} {...props} onClick={(e) => this.onLinkSelected(e, "my-bets")}>
                                            <span className="navbar-toggler-icon sport_icon myBets"></span>
                                            {element.title}
                                        </li>
                                    );
                                }
                                if (element.title === "Search") {
                                    return (
                                        <li className={"nav-item" + activeTab} key={element.title} {...props} onClick={(e) => this.onSearchClicked(e, "casino-search")}>
                                            <span className="navbar-toggler-icon sport_icon search"></span>
                                            {element.title}
                                        </li>
                                    );
                                }
                                return (
                                    <li className={"nav-item" + activeTab} key={element.title}>
                                        <Link to={element.href} {...props} onClick={(e) => this.handleClick(e, element.title.toLowerCase())}>
                                            <span className={"navbar-toggler-icon " + element.icon}></span>
                                            {element.title}
                                        </Link>
                                    </li>
                                );
                            })
                        }
                        {!showCasinoMenu &&
                            this.defaultFooterMenu.map((element) => {
                                const props = {};
                                const activeTab = this.handleActiveTab() === element.title.replace(/ +/g, "").toLowerCase() ? " active" : "";

                                if (element.dataLink) {
                                    props["data-link"] = element.dataLink;
                                }
                                if (element.title === "My Bets") {
                                    return (
                                        <li className={"nav-item" + activeTab} key={element.title} {...props} onClick={(e) => this.onLinkSelected(e, "my-bets")}>
                                            <span className="navbar-toggler-icon sport_icon myBets"></span>
                                            My Bets
                                        </li>
                                    );
                                }
                                return (
                                    <li className={"nav-item" + activeTab} key={element.title}>
                                        <Link to={element.href} {...props} onClick={(e) => this.handleClick(e, element.title.toLowerCase())}>
                                            <span className={"navbar-toggler-icon sport_icon " + element.icon + (window.location.pathname.indexOf("multiples") !== -1 ? " multiples-icon" : "")}></span>
                                            {element.title}
                                            {element.title === "Betslip" && GBEglobal.mode !== ModeTypes.Multiples &&
                                                <span className={"betslip-counter" + (this.state.betslipCounter > 0 ? " enabled" : "")}>
                                                    <span className="counter">{this.state.betslipCounter || ""}</span>
                                                </span>
                                            }
                                            {configurationSettings.modes.indexOf("Multiples") !== -1 && element.title === "Multiples" &&
                                                <span className={"betslip-counter" + (this.state.multipleBetslipCounter > 0 ? " enabled" : "")}>
                                                    <span className="counter">{this.state.multipleBetslipCounter || ""}</span>
                                                </span>
                                            }
                                        </Link>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </nav>
            </ErrorBoundary >
        );
    }
}

export { MobileFooter };